import classNames from "classnames";
import React from "react";
import { useClasses, AdminContent, AdminPageHead, StateHandler, } from "../../";
const styles = (theme) => ({
    main: {
        height: "calc(100vh - 204px) !important",
        [theme.breakpoints.down("sm")]: {
            height: "calc(100vh - 123px) !important",
        },
        "@media print": {
            height: "auto",
        },
    },
    overlay: {
        backgroundColor: "rgba(236, 236, 236, 0.95)",
    },
});
export default function AdminPage(props) {
    var _a, _b;
    const classes = useClasses(styles);
    return (React.createElement(StateHandler, { state: props.state || "ok", override: {
            ...(props.override || {}),
            overlay: classNames([(_a = props.override) === null || _a === void 0 ? void 0 : _a.overlay, classes.overlay]),
        }, translationGroup: props.translationGroup, onErrorReset: props.onErrorReset },
        React.createElement(AdminContent, { override: { main: classNames([((_b = props.override) === null || _b === void 0 ? void 0 : _b.main) || classes.main]) }, submenu: React.createElement(React.Fragment, null,
                React.createElement(AdminPageHead, { icon: props.icon, title: props.title, breadcrumbs: props.breadcrumbs }, props.actions),
                props.subhead), overlayPages: props.overlayPages }, props.children)));
}
